
<p-confirmDialog />

<div class="plan-page-container">
  <div class="plan-page-header">
    <h3>Work Notes</h3>
    <span class="notes-count-badge">{{ getAllNotes(notes).length }} note{{ getAllNotes(notes).length !== 1 ? 's' : '' }}</span>
  </div>

  <!-- Add Note Form -->
  <div class="add-note-form" *ngIf="!replyingToNote && !readonly">
    <textarea
      class="p-inputtext note-textarea"
      [(ngModel)]="newNote"
      placeholder="Add a work note..."
      rows="3"
      [disabled]="loading"
      (keydown.enter)="$event.preventDefault(); addNote()"></textarea>
    <div class="note-form-actions">
      <div class="checkbox-item">
        <input
          type="checkbox"
          id="sendEmail-{{projectId}}"
          [(ngModel)]="sendEmailNotification"
          [disabled]="loading" />
        <label class="checkbox-label" for="sendEmail-{{projectId}}">Send email notification</label>
      </div>
      <p-button
        label="Add Note"
        icon="pi pi-send"
        (onClick)="addNote()"
        [disabled]="!newNote.trim() || loading"
        severity="info"
        size="small" />
    </div>
  </div>

  <!-- Notes List -->
  <div class="notes-list" *ngIf="!loading && notes.length > 0">
    <div *ngFor="let note of notes" class="note-thread">
      <ng-container *ngTemplateOutlet="noteTemplate; context: { $implicit: note, level: 0 }"></ng-container>
    </div>
  </div>

  <!-- Note Template (Recursive) -->
  <ng-template #noteTemplate let-note let-level="level">
    <div
      class="note-card"
      [ngClass]="{ 'note-card--own': isOwnNote(note), 'note-card--reply': level > 0 }"
      [style.margin-left.px]="level * 24">
      <div class="note-card-header">
        <div class="note-author">
          <div class="note-avatar">{{ getInitials(note.authorName) }}</div>
          <div class="note-author-details">
            <span class="note-author-name">{{ note.authorName }}</span>
            <span class="note-author-email">{{ note.authorEmail }}</span>
          </div>
        </div>
        <div class="note-meta">
          <span class="note-date">{{ formatDate(note.createdAt) }}</span>
          <p-button
            *ngIf="!readonly && canDeleteNote(note)"
            icon="pi pi-trash"
            (onClick)="deleteNote(note)"
            [text]="true"
            severity="danger"
            size="small"
            pTooltip="Delete note"
            tooltipPosition="left" />
        </div>
      </div>
      <div class="note-body">{{ note.note }}</div>
      <div class="note-card-actions" *ngIf="!readonly">
        <p-button
          label="Reply"
          icon="pi pi-reply"
          (onClick)="startReply(note)"
          [text]="true"
          severity="secondary"
          size="small" />
      </div>

      <!-- Reply Input -->
      <div class="reply-form" *ngIf="replyingToNote?.id === note.id">
        <textarea
          class="p-inputtext note-textarea note-textarea--reply"
          [(ngModel)]="replyText"
          placeholder="Write a reply..."
          rows="2"
          [disabled]="loading"></textarea>
        <div class="note-form-actions">
          <p-button
            label="Cancel"
            icon="pi pi-times"
            (onClick)="cancelReply()"
            [text]="true"
            severity="secondary"
            size="small" />
          <p-button
            label="Reply"
            icon="pi pi-send"
            (onClick)="addReply()"
            [disabled]="!replyText.trim() || loading"
            severity="info"
            size="small" />
        </div>
      </div>

      <!-- Nested Replies -->
      <div *ngIf="note.replies && note.replies.length > 0">
        <div *ngFor="let reply of note.replies">
          <ng-container *ngTemplateOutlet="noteTemplate; context: { $implicit: reply, level: level + 1 }"></ng-container>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="!loading && notes.length === 0">
    <div class="empty-icon"><i class="pi pi-comments"></i></div>
    <p class="empty-message">No work notes yet</p>
    <p class="empty-description">Be the first to add a note for this project</p>
  </div>

  <!-- Loading State -->
  <div class="loading-state" *ngIf="loading && notes.length === 0">
    <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem; color: var(--primary-color);"></i>
    <p style="margin: 0; font-size: var(--font-size-sm); color: var(--text-color-secondary);">Loading notes...</p>
  </div>
</div>
